import { Layout } from 'components';
import { Outlet } from 'libs/navigation';

import { NavigationMiddleware } from './NavigationMiddleware';

export const Main = () => (
  <NavigationMiddleware>
    {({
      isAuthPage,
      isTwoFactorConnectionPage,
      isUpdateExpiredPasswordPage,
    }) => {
      if (
        isAuthPage ||
        isTwoFactorConnectionPage ||
        isUpdateExpiredPasswordPage
      ) {
        return <Outlet />;
      }

      return (
        <Layout isLogoShort>
          <Outlet />
        </Layout>
      );
    }}
  </NavigationMiddleware>
);
